import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatabaseLineageCountsFragmentGql } from './DatabaseLineageCountsFragmentGql';

export const DatabaseLineageCountsFilteredByTableQueryGql: DocumentNode = gql`
query DatabaseLineageCountsFilteredByTableQuery($databaseId: ID!, $tableId: ID!, $publishedConnectionsLineageEnabled: Boolean!) {
  databases(filter: { id: $databaseId }) {
    ...DatabaseLineageCountsFragment
    filteredTablesConnection: tablesConnection(filter: { id: $tableId }) {
      nodes {
        name
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamFlowsConnection {
          totalCount
        }
        upstreamDatasourcesConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamVirtualConnectionsConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
          totalCount
        }
        downstreamVirtualConnectionTablesConnection @flag(enabled: $publishedConnectionsLineageEnabled) {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
${DatabaseLineageCountsFragmentGql}
`;
